import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';

import { useRemoveAdmin } from '@/features/organization-admins/hooks/mutation/use-remove-admin';

interface Props extends DialogActions {
  adminId: number;
  adminEmail: string;
}

const RemoveOrganizationAdminDialog = ({ open, onCancel, adminEmail, adminId }: Props) => {
  const { t } = useTranslation(['common', 'organizationAdmins']);

  const { mutate, isPending } = useRemoveAdmin(onCancel);

  return (
    <Dialog
      open={open}
      title={t('common:areYouSure')}
      onCancel={onCancel}
      onConfirm={() => mutate(adminId)}
      variant="warning"
      isConfirmButtonDisabled={!adminId}
      isConfirmButtonSubmitting={isPending}>
      <Typography>
        {`${t('organizationAdmins:removeDialogMessage', {
          email: adminEmail,
        })}`}
      </Typography>
    </Dialog>
  );
};

export default RemoveOrganizationAdminDialog;
